<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div class="ts-overflow-x-scroll">
				<table class="ts-w-full mt-2 custom-table">
					<thead>
						<tr>
							<th class="ts-bg-gray-200 ts-py-1 ts-px-2">{{ $t('feePredefineItem.feeType') }}</th>
							<th class="ts-bg-gray-200 ts-py-1 ts-px-2">{{ $t('feePredefineItem.feeName') }}</th>
							<th class="ts-bg-gray-200 ts-py-1 ts-px-2">{{ $t('feePredefineItem.descrtiption') }}</th>
							<th class="ts-bg-gray-200 ts-py-1" style="width:80px">{{ $t('feePredefineItem.qty') }}</th>
							<th class="ts-bg-gray-200 ts-py-1" style="width:120px">{{ $t('feePredefineItem.fee') }}</th>
							<th class="ts-bg-gray-200 ts-py-1" style="width:120px">{{ $t('feePredefineItem.feeAmount') }}</th>
							<th class="ts-bg-gray-200 ts-py-1 ts-px-2" style="width:1%">
								<a href="#" @click.prevent="addNewRow">
									<i class="fa fa-plus"></i>
								</a>
							</th>
						</tr>
					</thead>
	
					<tbody>
						<tr v-for="(item, index) in localItems" :key="item._uuid">
							<td class="ts-py-2 ts-px-2">
								<a-select v-model.number="item.fee_type_id" :options="feeTypeOptions" style="min-width:120px" class="ts-w-full"
									@change="onFeeTypeChange(item)" />
							</td>
	
							<td class="ts-py-2 ts-px-2">
								<a-select v-model.number="item.fee_setup_id" :options="getFeeSetupOptions(item)"
									@change="(_, option) => onFeeSetupChange(item, option)" placeholder="Select Fee" :show-search="true"
									:filter-option="filterFeeOption" :disabled="!item.fee_type_id || loadingFeeSetups[item.fee_type_id]"
									style="min-width:180px" class="ts-w-full"	
								/>
							</td>
	
							<td class="ts-py-2 ts-px-2">
								<input v-model="item.fee_description" @input="emitUpdate" 
									style="min-width:120px" class="form-control"
								/>
							</td>
	
							<td class="ts-py-2 ts-px-2">
								<input type="number" min="1" v-model.number="item.quantity" @input="emitUpdate"
									style="min-width:80px" class="form-control"
								/>
							</td>
							<td class="ts-py-2 ts-px-2">
								<input type="number" :value="item.fee_amount" readonly
									style="min-width:80px" class="form-control"
								/>
							</td>
	
							<td class="ts-py-2 ts-px-2">
								<input type="number" :value="item.fee_amount * item.quantity" readonly
									style="min-width:80px" class="form-control"
								>
							</td>
	
							<td class="ts-py-2 ts-px-2">
								<a href="#" @click.prevent="removeRow(index)">
									<i class="fa fa-trash text-red"></i>
								</a>
							</td>
						</tr>
						<tr>
							<td colspan="5" class="ts-text-right">
								<strong>{{ $t('feePredefineItem.totalAmount') }} : </strong>
							</td>
							<td class="ts-py-2 ts-px-2">
								<input type="number" 
								:value="calculateTotalAmount" readonly
								style="min-width:80px" class="form-control"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</ts-loading-banner>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	props: {
		value: { type: Object, required: true }
	},

	data() {
		return {
			localItems: [],
			loading: false,
			errors: new Errors(),
			feeTypes: [],
			feeSetupsByType: {},
			loadingFeeSetups: {},
			dataInitialized: false
		}
	},

	async mounted() {
		await this.fetchFeeTypes()

		if (this.value.fee_define_detail_list && this.value.fee_define_detail_list.length > 0 && this.value.grade_id) {
			await this.initializeFromEditData(this.value.fee_define_detail_list)
		}
	},

	computed: {
		feeTypeOptions() {
			return this.feeTypes.map(f => ({
				value: f.fee_type_id,
				label: f.fee_type_name
			}))
		},
		calculateTotalAmount() {
			return this.localItems.reduce((total, item) => {
				return total + (Number(item.fee_amount) * Number(item.quantity || 1))
			}, 0)
		}
	},

	methods: {
		...mapActions('feePredefineItem', ['formViewModel']),

		filterFeeOption(input, option) {
			const text = option.componentOptions.children[0].text
			return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		},

		async initializeFromEditData(detailList) {
			if (this.dataInitialized) return

			this.loading = true

			try {
				const feeTypeIds = [...new Set(detailList.map(d => d.fee_type_id).filter(Boolean))]

				await Promise.all(feeTypeIds.map(feeTypeId => this.loadFeeSetupsForType(feeTypeId)))

				this.localItems = detailList.map(d => {
					const item = {
						_uuid: Date.now() + Math.random(),
						fee_type_id: d.fee_type_id ? Number(d.fee_type_id) : null,
						fee_setup_id: d.fee_setup_id ? Number(d.fee_setup_id) : null,
						fee_description: d.fee_description || '',
						quantity: d.quantity || 1,
						fee_amount: d.fee_amount
					}

					if (d.id) {
						item.id = d.id
					}

					return item
				})

				this.dataInitialized = true

				await this.$nextTick()

			} catch (error) {
				console.error('Error initializing edit data:', error)
				this.$toasted.error(error.message)
			} finally {
				this.loading = false
			}
		},

		emitUpdate: _.debounce(function () {
			const cleanedList = this.localItems.map(row => {
				const cleaned = {
					fee_type_id: row.fee_type_id,
					fee_setup_id: row.fee_setup_id,
					fee_description: row.fee_description,
					quantity: row.quantity,
					fee_amount: row.fee_amount
				}

				if (row.id && row.id > 0) {
					cleaned.id = row.id
				}

				return cleaned
			})

			this.$emit('input', {
				...this.value,
				fee_define_detail_list: cleanedList
			})
		}, 100),

		addNewRow() {
			this.localItems.push({
				_uuid: Date.now() + Math.random(),
				fee_type_id: null,
				fee_setup_id: null,
				fee_description: '',
				quantity: 1,
				fee_amount: 0
			})
			this.emitUpdate()
		},

		removeRow(index) {
			this.localItems.splice(index, 1)
			this.emitUpdate()
		},

		getFeeSetupOptions(row) {
			if (!row.fee_type_id) {
				return []
			}

			const feeSetups = this.feeSetupsByType[row.fee_type_id] || []

			if (!feeSetups.length) {
				return []
			}

			const usedIds = this.localItems
				.filter(r => r._uuid !== row._uuid && r.fee_setup_id)
				.map(r => Number(r.fee_setup_id))

			return feeSetups
				.filter(f => !usedIds.includes(Number(f.fee_setup_id)))
				.map(f => ({
					value: Number(f.fee_setup_id),
					label: f.fee_name_en || f.fee_name_kh || 'N/A',
					fee_amount: f.fee_amount
				}))
		},

		async fetchFeeTypes() {
			try {
				const res = await this.formViewModel({ fnName: 'getFeeType' })
				this.feeTypes = res.data.data.getFeeType || []
			} catch (err) {
				console.error('Error fetching fee types:', err)
				this.$toasted.error(err.message)
			}
		},

		async loadFeeSetupsForType(feeTypeId) {
			if (!feeTypeId || !this.value.grade_id) {
				return
			}
			if (this.feeSetupsByType[feeTypeId]) {
				return
			}
			this.$set(this.loadingFeeSetups, feeTypeId, true)

			try {
				const res = await this.formViewModel({
					fnName: 'feeSetup',
					fee_type_id: feeTypeId,
					grade_id: this.value.grade_id
				})

				const feeSetups = res.data.data.feeSetup || []

				this.$set(this.feeSetupsByType, feeTypeId, feeSetups)

			} catch (err) {
				console.error(`Error loading fee setups for type ${feeTypeId}:`, err)
			} finally {
				this.$set(this.loadingFeeSetups, feeTypeId, false)
			}
		},

		async onFeeTypeChange(row) {
			row.fee_setup_id = null
			row.fee_description = ''

			if (!row.fee_type_id) {
				this.emitUpdate()
				return
			}

			await this.loadFeeSetupsForType(row.fee_type_id)
			this.emitUpdate()
		},

		onFeeSetupChange(row, option) {

			const feeAmount = option.data.props.fee_amount;

			if (!row.fee_type_id || !row.fee_setup_id) {
				return
			}

			const feeSetups = this.feeSetupsByType[row.fee_type_id] || []
			const selected = feeSetups.find(f => Number(f.fee_setup_id) === Number(row.fee_setup_id))

			if (selected) {
				row.fee_description = selected.fee_name_en || selected.fee_name_kh || ''
				row.fee_amount = feeAmount
				if (!row.quantity || row.quantity < 1) {
					row.quantity = 1
				}
			}

			this.emitUpdate()
		}
	},
	watch: {
		'value.fee_define_detail_list': {
			async handler(newList) {
				if (!this.dataInitialized && newList && newList.length > 0 && this.value.grade_id) {
					await this.initializeFromEditData(newList)
				}
			},
			deep: true,
			immediate: true
		},

		'value.grade_id': {
			handler(newGradeId, oldGradeId) {
				if (newGradeId !== oldGradeId) {
					this.feeSetupsByType = {}
					this.dataInitialized = false
				}
			}
		}
	}
}
</script>

<style scoped>
.custom-table {
	border-collapse: separate;
	border-spacing: 0;
}

.custom-table thead tr th:first-child {
	border-top-left-radius: 4px;
}

.custom-table thead tr th:last-child {
	border-top-right-radius: 4px;
}

.custom-table tbody tr:first-child td {
	padding-top: 8px;
}

.custom-table tbody tr td {
	padding-top: 3px;
	padding-bottom: 3px;
}
</style>